export default __webpack_public_path__ + "static/media/validate_conflict_btn.6e524f48.png";